export class CalendarEventDTO
{
    id: string;
    title: string;
    start: Date;
    end: Date;
    colour: string;
    allDay:boolean
}